import { render, staticRenderFns } from "./FormInputRadio.vue?vue&type=template&id=d0fdcf9c&scoped=true&"
import script from "./FormInputRadio.vue?vue&type=script&lang=ts&"
export * from "./FormInputRadio.vue?vue&type=script&lang=ts&"
import style0 from "./FormInputRadio.vue?vue&type=style&index=0&id=d0fdcf9c&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0fdcf9c",
  null
  
)

export default component.exports